
<div class="card" *blockUI="'section-block'">
    <div class="users-list-filter ml-1">
        <form>
            <div class="row">
                <div class="col-12 col-md-3">
                    <label>Firma Seç</label>
                    <ng-select [items]="companies" name="selectedCompany" bindLabel="companyName" bindValue="id"
                        (change)="filterCompany($event)" [(ngModel)]="companyId" [clearable]="false"></ng-select>
                </div>

                <div class="col-12 col-md-3">
                    <label>Marka Seç</label>
                    <ng-select [items]="brands" name="selectedBrand" bindValue="id" bindLabel="brandName"
                        (change)="filterBrand($event)" [(ngModel)]="brandId" [clearable]="false">
                    </ng-select>
                </div>

                <div class="col-12 col-md-3">
                    <label>Model Seç</label>
                    <ng-select name="selectedBrandModel" [searchFn]="searchFn" [items]="brandsModel"
                        bindLabel="name" bindValue="id" groupBy="brandName" (change)="filterBrandModel($event)"
                        [(ngModel)]="brandModelId" [clearable]="false">
                        <ng-template ng-optgroup-tmp let-item="item">
                            {{ item.brandName || 'Unnamed group' }}
                        </ng-template>
                    </ng-select>
                </div>

                <div class="col-12 col-md-2">
                    <label>Tür Seç</label>
                    <ng-select [items]="kinds" name="selectedCompany" bindLabel="typeName" bindValue="id"
                        (change)="filterKind($event)" [(ngModel)]="kindId" [clearable]="false">
                    </ng-select>
                </div>

                <div class="mt-2">
                    <button type="button" class="btn btn-icon btn-outline-primary" rippleEffect
                        (click)="clearFilters()">
                        <span [data-feather]="'trash'"></span>
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div class="row d-flex align-items-center mt-1 mb-1">
        <div class="col-12 d-flex justify-content-between align-items-center">
            <div class="row" style="padding-left: 1rem;">
                <button class="btn btn-primary ml-1" rippleEffect (click)="createDevice()">
                    <i data-feather="plus" class="d-sm-none d-inline-block"></i>
                    <span class="d-none d-sm-inline-block">Cihaz Ekle</span>
                </button>

                <button class="btn btn-warning ml-1" rippleEffect (click)="createDeliveryDevice('teslim alındı')">
                    <i data-feather="plus" class="d-sm-none d-inline-block"></i>
                    <span class="d-none d-sm-inline-block">Cihaz Teslim Alma</span>
                </button>

                <button class="btn btn-info ml-1" rippleEffect (click)="createDeliveryDevice('teslim edildi')">
                    <i data-feather="plus" class="d-sm-none d-inline-block"></i>
                    <span class="d-none d-sm-inline-block">Cihaz Teslim Etme</span>
                </button>
            </div>

            <div class="d-flex align-items-center">
                <label class="d-flex align-items-center mr-2">
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                        (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </label>
                <label class="d-flex align-items-center mr-1">
                    <input type="search" placeholder="Bul" class="form-control" (keyup)="filterUpdate($event)"
                        (search)="filterUpdate($event)" />
                </label>
            </div>
        </div>
    </div>

    <ngx-datatable #table [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;"
        [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'}" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50"
        [footerHeight]="50" [scrollbarH]="true" rowHeight="auto" (activate)="onActivate($event)">

        <ngx-datatable-column name="Sorumlu Kişi" prop="name" [width]="200" class="ellipsis-column">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.name}} {{row.lastName}}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Firma" prop="companyName" [width]="300"
            class="ellipsis-column"></ngx-datatable-column>
        <ngx-datatable-column name="Tür" prop="typeName" class="ellipsis-column" [width]="200"></ngx-datatable-column>
        <ngx-datatable-column name="Seri No" prop="seriNo" class="ellipsis-column" [width]="200"></ngx-datatable-column>
        <ngx-datatable-column name="Marka Model" class="ellipsis-column" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.brandName}} {{row.modelName}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="#" [width]="75" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                    <!-- stopPropagation burada ekleniyor -->
                    <button class="btn btn-icon btn-flat-warning" (click)="updateDevice(row.id, $event)">
                        <span [data-feather]="'edit'"></span>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>


                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event,row)">
                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                            </ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>